import React from 'react';
import useSafeState from '../../../../../useSafeState'
import * as api from '../../../../../Auth/auth'
import TableCard from '../../../../../components/Table/TableCard';
import ButtonGene from '../../../../../components/Button/ButtonGene';



export function DrugtypeTableData() {

  const [value, setValue] = useSafeState({});
  const [data, setData] = React.useState(React.useMemo(() => []));
  const [loading, setLoading] = React.useState(false);
    
    React.useEffect( () => {
      getData()
  }, [])

  async function getData() {
    
    setLoading(true)
    const response = await api.drugtypes();
    const d = handleData(response)
    setData( d )
    setLoading(false)
           // NO MEMORY LEAK
    setValue({ key: 'value' });
    }



    const handleData = (response) => {
      let dataContainer = []
              for (let i in response) {      
                dataContainer.push(     {    'col1': response[i].id,
                                              'col2': response[i].gene,
                                              'col3': response[i].genotype,
                                              'col4': response[i].phenotype,
                                              'col5': response[i].drugs,
                                              'col6': response[i].sample,
                                              'col7': response[i].owner
                                          },
                                  );   
              }
              return (dataContainer)
            }

  const columns = React.useMemo(
      () => [
          {
            header: 'PGx Gene',
            accessorKey: 'col2',
            cell: info => <ButtonGene name={info.getValue()} action={() => {"do something"}} />,
              },
          {
            header: 'Genotype',
            accessorKey: 'col3',
            cell: info => info.getValue(),
            },
                {
                  header: 'Phenotype',
                  accessorKey: 'col4',
                  cell: info => info.getValue(),
                    },
                    {
                      header: 'Related Drugs',
                      accessorKey: 'col5',
                      cell: info => info.getValue(),
                        },
      ],
      []
      )

return (

<div>
      { loading && <span> Please wait ... fetching data </span>}
      <TableCard columns={columns} data={data} />
</div>
);
}